var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "off"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "space",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.64125,14.3175 C17.8591165,11.4020359 17.4387625,7.26669502 14.6796123,4.85714053 C11.9204621,2.44758604 7.76618131,2.58791729 5.1759243,5.1781743 C2.58566729,7.76843131 2.44533604,11.9227121 4.85489053,14.6818623 C7.26444502,17.4410125 11.3997859,17.8613665 14.31525,15.6435 L19.212,20.54025 C19.5808011,20.899994 20.1691989,20.899994 20.538,20.54025 C20.9038192,20.1739421 20.9038192,19.5805579 20.538,19.21425 L15.64125,14.3175 Z M5.0625,10.125 C5.0625,7.32905845 7.32905845,5.0625 10.125,5.0625 C12.9209415,5.0625 15.1875,7.32905845 15.1875,10.125 C15.1875,12.9209415 12.9209415,15.1875 10.125,15.1875 C7.33042908,15.1841938 5.06580621,12.9195709 5.0625,10.125 Z",
    id: "Shape",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fba17017d141f5ad8fa6f338a50545c3.svg";
export { ForwardRef as ReactComponent };